import { useRef, useState } from 'react';
import useClickOutside from '../../services/Helpers/useClickOutside';
import { Button, RowContainer, Typography } from '../common';
import IconComponent from '../Icon';

const openInNewWindow = (url) => {
    window.open(url, '_blank').focus();
};

const HelpCenter = () => {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);
    useClickOutside(dropdownRef, setIsOpen);

    const openAgentGuide = () => {
        setIsOpen(false);
        openInNewWindow(
            'https://confluence.external-share.com/content/0458293f-dc36-46ab-a8cc-cede3983cb32/2974449665'
        );
    };

    const openTeamLeaderGuide = () => {
        setIsOpen(false);
        openInNewWindow(
            'https://confluence.external-share.com/content/0458293f-dc36-46ab-a8cc-cede3983cb32/2977005569'
        );
    };

    const openTroubleshooting = () => {
        setIsOpen(false);
        openInNewWindow(
            'https://confluence.external-share.com/content/0458293f-dc36-46ab-a8cc-cede3983cb32/2994733061'
        );
    };

    return (
        <div
            ref={dropdownRef}
            className={`${isOpen && 'shadow-cards bg-white'} relative h-full z-50`}
        >
            <RowContainer
                spacing="medium"
                className={`z-50 h-full px-4 items-center cursor-pointer`}
                onClick={() => setIsOpen(!isOpen)}
            >
                <div className="flex-shrink-0">
                    <IconComponent icon={'help'} height={32} width={32} />
                </div>
            </RowContainer>
            <div
                className={`navbar-dropdown-menu ${
                    isOpen && 'open shadow-md'
                } absolute w-min-content px-4 rounded-b-xl bg-white z-30 `}
            >
                <Typography variant="heading3.2" className={'mt-2'} color="grey-dark">
                    Guides
                </Typography>
                <Button type="link" onClick={openAgentGuide}>
                    Agent
                </Button>
                <Button type="link" onClick={openTeamLeaderGuide}>
                    Team&nbsp;Leader
                </Button>
                <Typography variant="heading3.2" color="grey-dark">
                    Troubleshooting
                </Typography>
                <Button type="link" onClick={openTroubleshooting}>
                    How&nbsp;Do&nbsp;I&nbsp;Sign&nbsp;In/Login
                </Button>
                <Button type="link" onClick={openTroubleshooting}>
                    The&nbsp;Softphone&nbsp;doesn't&nbsp;appear/work
                </Button>
                <Button type="link" onClick={openTroubleshooting}>
                    Softphone&nbsp;constantly&nbsp;shows&nbsp;loading/error
                </Button>
            </div>
        </div>
    );
};

export default HelpCenter;
